module.exports = __webpack_public_path__ + "static/media/Autodesk-light.bb2c22ae.webp";